// extracted by mini-css-extract-plugin
export default {"pageSpace":"page-space_pageSpace__TYUNn","excludeMobileSpace":"page-space_excludeMobileSpace__W0K1K"};